export const VALIDATION_ERROR = '/errors/validation-error'
export const PASSWORD_EDIT_FORM_NAME = 'password-edit-form'
